import React from "react";
import { ErrorMessage, Field } from "formik";
import styled from "@emotion/styled";

const DefaultField = (props) => {
    const { name, type, label } = props;

    // RETURN
    return (
        <Container>
            <FieldFake
                name={name}
                type={type}
                label={label}
                placeholder={label}
                {...props}
            />
            <ErrorMessageCustom name={name} component={CustomError} />
        </Container>
    );
};

export default DefaultField;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
`;

const CustomError = styled.span`
    font-size: 0.89rem;
    font-weight: 700;
    color: #f8423f;
`;

const FieldFake = styled(Field)`
    width: 100%;
    padding: 1rem 1rem 0 1rem;
    height: 3rem;
    border: none;
    border-bottom: 2px solid #b31d15;

    ::placeholder {
        color: #3b3b3b;
    }
    
    &:focus {
        outline: none;
        border-bottom: 2px solid #ff4d48;
    }
`;

const ErrorMessageCustom = styled(ErrorMessage)`
    position: absolute;
    left: 10px;
    top: 3px;

    width: fit-content;
    overflow: visible;
`;
